<template>
  <div>
    <div class="row FAQpanel">
      <div class="helptitle">Frequently asked questions</div>
      <ul class="col-12 faq-list">
        <li v-for="faq in faqs" v-bind:key="faq.id">
          <div class="helpblock">
            <div class="helplink">{{faq.link}}</div>
            <div class="helpcontent" v-html="faq.content"></div>
          </div>
        </li>
      </ul>
        <div class="manage-switch-link" >Did you forget your password? You can <a :href="resetUrl"><strong>reset it</strong></a>.</div>
    </div>

  </div>
</template>
<script>
  import domainUtilityMixin from "../mixins/DomainMixin";
  export default {
    name: 'ChangePasswordFAQ',
    data() {
      return {
        resetUrl: process.env.VUE_APP_RESET_PASSWORD_PAGE_URL,
        faqs: domainUtilityMixin.methods.getDomainFAQs(this.$store.state.domain),
      };
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .FAQpanel /deep/ a{
    color: #5F60FF !important;
  }
  .FAQpanel /deep/ a:hover{
    color: #1F20BF !important;
  }
  a:hover{
    text-decoration: underline !important;
    color: #1F20BF !important;
  }
  .FAQpanel {
    padding: 30px 30px 0px 40px
  }
  .manage-switch-link >>> a {
    color: #5F60FF !important;
    text-decoration: none;
  }

  @media (max-width: 767px) {
    .FAQpanel {
      padding: 30px 0 0 0;
      margin-bottom: 30px;
    }
    .helptitle {
      font-size: 20px;
    }
  }
  .helptitle {
    padding-bottom: 20px;
    font-size: 26px;
    color: #000000;
    font-weight: bolder;
  }
  .faq-list {
    padding: 0;
    list-style: none;
  }
  .helpblock {
    margin-bottom: 15px;
  }
  .helpcontent {
    font-size: 16px;
    color: #000000;
    margin: 7px 0 30px 0;
    display: block;
    text-overflow: ellipsis;
  }
  .helplink{
    font-size: 16px;
    color: #000000;
    font-weight: bolder;
    font-family: artifaktElementBold;
  }
  .manage-switch-link {
    padding: 0 30px 0px 0px;
    font-size: 16px;
  }
  @media (max-width: 576px) {
    .helpcontent {
      font-size: 13px;
    }
    .helplink{
      font-size: 13px;
    }
    .manage-switch-link {
      font-size: 13px;
    }
    .helptitle {
      font-size: 20px;
    }
  }
  @media (max-width: 400px) {
    .helpcontent {
      font-size: 11px;
    }
    .helplink{
      font-size: 11px;
    }
    .manage-switch-link {
      font-size: 11px;
    }
    .helptitle {
      font-size: 20px;
    }
  }
</style>
